export default __webpack_public_path__ + "static/media/mobile_balance.e76c871c.svg";